import { View } from "binder"
import { AccountGatewaySelectorViewModel } from "src/erp/arap/rawData/accountGatewaySelector-viewModel";
import { AccountGatewayViewModel } from "./accountGateway-viewModel"

export class AccountGatewayView extends View<AccountGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-6E3D8C17-E495-4EEB-9FA6-8D132952504C"
    }
    loadHtml(): string {
        let element = require('./accountGateway.html').default;
        let style = require('./accountGateway.less');
        return element;
    }
    constructor() {
       super();
    }
    public set accountSelector(v: AccountGatewaySelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountGatewaySelectorViewModel { return this._accountSelector;} private _accountSelector: AccountGatewaySelectorViewModel;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
}
